import React, { useEffect } from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { compose } from "recompose";

import useStores from "@hooks/useStores";

import withStores from "@framework/src/libs/withStores";
import withStyles from "@framework/src/libs/withStyles";

import SnackBar from "./Shared/SnackBar";

import { styles, stores } from "./.config";

const InfoSnackbar = ({
	store,
	autoHideDuration,
	transitionDuration,
	...props
}) => (
	<SnackBar
		transitionDuration={{
			enter: store.processing ? 0 : transitionDuration.enter,
			exit: transitionDuration.exit,
		}}
		snackbarStore={store}
		autoHideDuration={store.processing ? undefined : autoHideDuration}
		onClose={() => store.onClose()}
		{...props}
	/>
);

InfoSnackbar.defaultProps = {
	autoHideDuration: 6000,
	transitionDuration: { enter: 300, exit: 300 },
};

InfoSnackbar.propTypes = {
	store: PropTypes.object.isRequired,
	autoHideDuration: PropTypes.number,
	transitionDuration: PropTypes.shape({
		enter: PropTypes.number,
		exit: PropTypes.number,
	}),
};

const InfoBanner = ({ message }) => (
	<React.Fragment>
		{message && (
			<React.Fragment>
				<div className="alert alert-info" role="alert">
					<i className="fa fa-info-circle" /> {message}
				</div>
			</React.Fragment>
		)}
	</React.Fragment>
);

InfoBanner.propTypes = {
	message: PropTypes.string.isRequired,
};

const Info = compose(
	withStyles(styles),
	withStores(stores),
	observer
)(({ store, banner, ...props }) => {
	const { alertStore } = useStores();

	useEffect(() => {
		alertStore.init(store);
		return () => alertStore.remove(store);
	}, []);

	if (banner === true) {
		return <InfoBanner {...props} message={store.message} />;
	}
	return <InfoSnackbar {...props} store={store} />;
});

Info.propTypes = {
	banner: PropTypes.bool,
	store: PropTypes.object.isRequired,
	autoHideDuration: PropTypes.number,
};

export default Info;
